import { reader } from './reader';

// ----------------------------------------------------------------------------

export type TypeToUrlConfig = {
    fnSuccess?: (url: string) => void;
    fnError?: (evt: ProgressEvent<FileReader>) => void;
};

// ----------------------------------------------------------------------------

async function toUrl(file: File, config: TypeToUrlConfig): Promise<any> {
    return reader(file, {
        fnSuccess: function (data): any {
            //
            const blob = new Blob([data]);
            const urlCreator = window.URL || window.webkitURL;
            const url = urlCreator.createObjectURL(blob);

            // If using function success
            if (typeof config.fnSuccess === 'function') {
                config.fnSuccess(url);
            }
        },
        fnError: function (evt): any {
            // If using function error
            if (typeof config.fnError === 'function') {
                config.fnError(evt);
            }
        },
    });
}

// ----------------------------------------------------------------------------

export default toUrl;
